import {
  GETKYBDETAILSLIST_SUCCESS,
  GETKYBDETAILSLIST_FAILED,
  RESET_GETKYBDETAILSLIST,
  LOADING_GETKYBDETAILSLIST,
  NETWORK_ERROR_GETKYBDETAILSLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetgetKybDetailsReportList = () => {
  return { type: RESET_GETKYBDETAILSLIST };
};

const getKybReportDetailsListReq =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETKYBDETAILSLIST });
    await partnerServices
      .post("getKybDetailsList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(getKybDetailsListsuccess(res.data));
            break;
          default:
            dispatch(getKybDetailsListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETKYBDETAILSLIST,
          payload: err,
        });
      });
  };
function getKybDetailsListsuccess(data) {
  return {
    type: GETKYBDETAILSLIST_SUCCESS,
    payload: data,
  };
}
function getKybDetailsListFailed(data) {
  return {
    type: GETKYBDETAILSLIST_FAILED,
    payload: data,
  };
}

export { resetgetKybDetailsReportList, getKybReportDetailsListReq };
